import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ServicePages.css';
import { fadeInUp } from '../constants/animations';

function AIPhoneAssistantPage() {
  return (
    <main className="service-page">
      <div className="service-container">
        <motion.div className="service-hero" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }}>
          <motion.h1 variants={fadeInUp} custom={0}>AI Phone Assistant</motion.h1>
          <motion.p variants={fadeInUp} custom={1}>Never miss a lead. AI answers every call, captures details, and routes the job instantly.</motion.p>
        </motion.div>

        <div className="service-section">
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>24/7 availability</h4>
            <p>Every call is answered, even after hours and weekends.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Lead capture</h4>
            <p>Name, job type, and urgency are captured and delivered to your team.</p>
          </motion.div>
          <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
            <h4>Smart summaries</h4>
            <p>Clear call summaries keep your team aligned and fast to respond.</p>
          </motion.div>
        </div>

        <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
          <h3>What you get</h3>
          <ul className="service-list">
            <li>AI‑answered calls with natural conversation</li>
            <li>Lead capture (name, job type, urgency)</li>
            <li>Instant delivery to your team</li>
            <li>Consistent, professional caller experience</li>
          </ul>
        </motion.div>

        <div className="service-split">
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
            <h4>Who it’s for</h4>
            <p>Any business that relies on inbound calls and wants zero missed leads.</p>
          </motion.div>
          <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
            <h4>Works with your flow</h4>
            <p>Route calls, send summaries, and keep your team in sync.</p>
          </motion.div>
        </div>

        <motion.div className="service-faq" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <motion.h3 variants={fadeInUp} custom={0}>FAQs</motion.h3>
          <div className="service-faq-grid">
            <motion.div className="service-faq-item" variants={fadeInUp} custom={1}>
              <h5>Does it replace my team?</h5>
              <p>No. It covers missed calls and captures details for follow‑up.</p>
            </motion.div>
            <motion.div className="service-faq-item" variants={fadeInUp} custom={2}>
              <h5>Can I customize prompts?</h5>
              <p>Yes. We tailor the flow to your business and services.</p>
            </motion.div>
          </div>
        </motion.div>

        <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
          <Link to="/plans">Get Started</Link>
        </motion.div>
      </div>
    </main>
  );
}

export default AIPhoneAssistantPage;
